import { useState, useContext } from "react";
import {
  Box,
  Grid,
  Table,
  TableRow,
  TableCell,
  TableBody,
  TableHead,
  Typography,
  TableContainer,
} from "@mui/material";
//Srcs
import { AuthContext } from "../../Context/AuthContext";
import "../../Style/pagestyle.scss";
import EmptyData from "../../Components/Include/EmptyData";
import LoadingPage from "../../Utils/LoadingPage";
import FooterPagination from "../../Utils/FooterPagination";
import {
  ButtonCreate,
  SearchTextField,
  PageHeaderTitle,
} from "../../Utils/Component";
import MajorForm from "../../Components/Major/MajorForm";
import MajorAction from "../../Components/Major/MajorAction";
import useWithDimension from "../../Hooks/useWithDimension";
import { useGetMajorPagination } from "../../Hooks/useGetMajorPagination";

export default function Major() {
  const { t, } = useContext(AuthContext);

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const {
    page,
    limit,
    loading,
    refetch,
    setPage,
    tableData,
    setLoading,
    handleLimit,
    handleSearch,
    paginationData,
  } = useGetMajorPagination();

  // ======================= Resize width Screen ======================
  const { width } = useWithDimension();
  return (
    <div className="page-container">
      <PageHeaderTitle
        classPage={t("class-page-title")}
        classSlash="slash-title"
        routeTo={"/setting"}
        pageTitle={t("page_setting")}
        detailTitle={t("page_major")}
      />

      <Box sx={{ marginTop: "20px" }}>
        <Grid container spacing={3}>
          <Grid item xs={6} sm={6} md={4} lg={3} xl={2.4}>
            <Typography className={t("class-name-text-field-title")}>
              {t("search")}
            </Typography>
            <SearchTextField
              className={"text-field"}
              handleSearch={handleSearch}
            />
          </Grid>

          <Grid item xs={6} sm={6} md={8} lg={9} xl={9.6}>
            <ButtonCreate
              handleOpen={handleOpen}
              classBtn={"btn-create"}
              classIcon={"icon-add"}
            />

            {open && (
              <MajorForm
                open={open}
                handleClose={handleClose}
                setRefetch={refetch}
                dialogTitle="Create"
              />
            )}
          </Grid>
        </Grid>
      </Box>

      <Box className="body-container">
        <TableContainer sx={{ maxWidth: `${width}px` }}> 
          <Table className="table" aria-label="simple table">
            <TableHead className="header-row ">
              <TableRow>
                <TableCell
                  className={t("class-name-header-title-start")}
                  width="4%"
                >
                  {t("no")}
                </TableCell>
                <TableCell className={t("class-name-header-title")} width="39%">
                  {t("thead_major_name")}(KH)
                </TableCell>
                <TableCell className={t("class-name-header-title")} width="50%">
                  {t("thead_major_name")}(ENG)
                </TableCell>

                <TableCell
                  className={t("class-name-header-title-end")}
                  width="7%"
                ></TableCell>
              </TableRow>
            </TableHead>
            {loading ? (
              <TableBody className="body">
                <TableRow className="body-row">
                  <TableCell
                    colSpan={4}
                    className="body-cell"
                    sx={{ bgcolor: "#fff" }}
                  >
                    <LoadingPage />
                  </TableCell>
                </TableRow>
              </TableBody>
            ) : (
              <>
                {tableData?.length === 0 || tableData?.length === undefined ? (
                  <TableBody className="body">
                    <TableRow className="body-row">
                      <TableCell colSpan={4} className="body-cell">
                        <EmptyData />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                ) : (
                  <>
                    <TableBody className="body">
                      {tableData?.map((row, index) => {
                        return (
                          <TableRow className="body-row" key={index}>
                            <TableCell className="body-cell-start">
                              {index + paginationData?.slNo}
                            </TableCell>
                            <TableCell className="body-cell">
                              {row?.majorsNameKh}
                            </TableCell>
                            <TableCell className="body-cell">
                              {row?.majorsNameEng}
                            </TableCell>
                            <TableCell className="body-cell-end" align="right">
                              <MajorAction
                                editData={row}
                                setRefetch={refetch}
                              />
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </>
                )}
              </>
            )}
          </Table>
        </TableContainer>

        {/* ============================ Pagination  ============================= */}
        <FooterPagination
          totalPages={paginationData?.totalPages}
          totalDocs={paginationData?.totalDocs}
          limit={limit}
          page={page}
          setPage={setPage}
          handleLimit={handleLimit}
          setLoading={setLoading}
        />
      </Box>
    </div>
  );
}
